import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  properties: [],
  totalPages: 0,
  data: {},
};

export default function properties(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@properties/LIST_PROPERTIES_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@properties/LIST_PROPERTIES_RESPONSE': {
        draft.loading = false;
        draft.properties = action.payload.properties;
        draft.totalPages = action.payload.totalPages;
        break;
      }
      case '@properties/GET_SECOND_BILLET_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@properties/GET_SECOND_BILLET_RESPONSE': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.totalPages = action.payload.totalPages;
        break;
      }
      case '@properties/GET_RESERVATION_FUNDS_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@properties/GET_RESERVATION_FUNDS_RESPONSE': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.totalPages = action.payload.totalPages;
        break;
      }
      default:
    }
  });
}
